import React, { useEffect, useRef, useState } from 'react'
import { withAuth } from '../AuthContext'
import { withRouter } from 'react-router-dom'
import { shouldTranslateTo } from '../../utils/utils'
import Cookies from 'universal-cookie'
import styled from 'styled-components'
import NewHeaderOnboarding from '../NewHeaderOnboarding'
import PhotoOnboarding from './PhotoOnboarding'
import BioOnboarding from './BioOnboarding'
import MyFreebirdPopup from './MyFreebirdPopup'
import MyFreebirdOpacityScreen from './MyFreebirdOpacityScreen'
import ChooseSubscriptionOnboardingMonthly from './ChooseSubscriptionOnboardingMonthly'
import ChoosePaymentOptionOnboardingMonthly from './ChoosePaymentOptionOnboardingMonthly'
import FeeSubscriptionOnboarding from './FeeSubscriptionOnboarding'
import EditEmailOnboarding from './EditEmailOnboarding'
import IntroOnboarding from './IntroOnboarding'
import ProofIdentityOnboarding from './ProofIdentityOnboarding'
import {
  ActionButtons,
  LoadingButton,
  Subtitle,
  Title,
} from '../Utils/CustomClasses'

const cookies = new Cookies()
const queryParams = new URLSearchParams(window.location.search)

const MyFreebirdSection = styled.section`
  position: relative;
`

const TopSectionContainer = styled.div`
  padding: ${(props) => (props.padding ? props.padding : '140px 20vw 140px')};

  @media screen and (max-width: 799px) {
    padding: ${(props) =>
      props.paddingsm ? props.paddingsm : '140px 5vw 140px'};
  }
`

const MainSectionContainer = styled.div`
  position: relative;
`

const TopSectionAction = styled.div`
  background-color: #154549;
  border: 1px solid #fff;
  border-radius: 8px;
  margin: 0 auto;
  padding: 30px;
  text-align: center;

  img {
    width: 130px;
  }

  @media screen and (max-width: 799px) {
    padding: 30px 10px;
  }
`

const SubtitleOnboard = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
`

const ProceedButton = styled(ActionButtons)`
  background-color: #0bac5d;
  width: -webkit-fill-available;
`

const ActionButton = styled(ProceedButton)`
  background-color: #eb5e55;
`

const ProceedButtonLoading = styled(LoadingButton)`
  background-color: #0bac5d;
  width: -webkit-fill-available;
`

const FlexRowOnboarding = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: stretch;
  padding-top: 140px;

  @media screen and (max-width: 799px) {
    flex-direction: column;
  }
`

const FrbLeft = styled.div`
  flex-basis: 15%;
  text-align: left;

  @media screen and (max-width: 590px) {
    padding: 0 10vw 20px;
  }

  @media screen and (max-width: 799px) {
    padding: 0 30vw 20px;
  }
`

const FrbMiddle = styled(FrbLeft)`
  flex-basis: 70%;
  text-align: center;

  @media screen and (max-width: 799px) {
    padding: 0 10vw;
  }
`

const FrbMiddleTop = styled.div`
  padding: 0 0 50px 0;
  width: 100%;
  text-align: center;

  img {
    width: 100%;
    max-width: 720px;
  }
`

const PromoBanner = styled.div`
  @media screen and (max-width: 590px) {
    display: none;
  }
`

const PromoBannerMob = styled.div`
  display: none;

  @media screen and (max-width: 590px) {
    display: block;
  }
`

const FrbMiddleBottom = styled.div`
  width: 100%;
  text-align: center;

  img {
    max-width: 420px;
  }
`

const FrbRight = styled(FrbLeft)`
  flex-basis: 15%;
  text-align: right;
`

const BackButton = styled(ActionButtons)`
  background-color: transparent;
  border: 1px solid #fff;
  padding: 6px 30px;
  margin: 5px 0 0 30px;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 200;

  @media screen and (max-width: 799px) {
    margin: 0 4vw;
    width: -webkit-fill-available;
  }
`

const MyFreebirdOnboardingSteps = (props) => {
  const [pageText, setPageText] = useState([])
  const [country, setCountry] = useState('')
  const [countriesNice, setCountriesNice] = useState([])
  const [onboardingStep, setOnboardingStep] = useState('--')
  const [progressStep, setProgressStep] = useState('1')
  const [emailCheckFail, setEmailCheckFail] = useState('')
  const [postedIntoCircle, setPostedIntoCircle] = useState(false)
  const [loading, setLoading] = useState(false)
  const [iAminSubscriptionFormPanel, setIAminSubscriptionFormPanel] =
    useState(false)
  const [forbiddenLinkClicked, setForbiddenLinkClicked] = useState([false, ''])
  const actionRef = useRef(null)

  useEffect(() => {
    setLoading(false)

    if (queryParams.get('p')) {
      setOnboardingStep(queryParams.get('p'))
      setProgressStep(queryParams.get('p'))
    }

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('profile-onboarding', language)
  }, [])

  useEffect(() => {
    if (props.auth.user.countryId && country.length <= 1) {
      axios
        .get('/api/countries-list')
        .then((response) => {
          const countriesNiceList = response.data.map((item) => {
            return { value: item.id, label: item.nicename }
          })
          const country = countriesNiceList.find(
            (c) => c.value === props.auth.user.countryId
          )
          setCountriesNice(countriesNiceList)
          setCountry(country.label)
        })
        .catch(function (error) {
          console.log('Request failure: ', error)
        })
    }

    if (queryParams.get('p') === '' || queryParams.get('p') === null) {
      setInterval(() => {
        if (props.auth.user.emailStatus === 'pending') {
          handleCheckEmail('auto')
        } else if (props.auth.user.emailStatus === 'verified') {
          window.open('/onboarding?p=st', '_self')
        }
      }, 8000)
    }
  }, [props.auth.user])

  useEffect(() => {
    console.log('>>>>> onboardingStep: ' + onboardingStep)

    // Payment made - now upload proof of ID
    if (onboardingStep === 'db2' && props.auth.user.id !== '') {
      axios
        .get(`/api/VYGVA82re2f8e2/token/${props.auth.user.id}`)
        .then((response) => {
          window.sessionStorage.setItem('commAt', response.data.access_token)
        })
        .catch((err) => {
          console.log('Error logging into Circle: ', err)
        })

      console.log(
        '>>>>>>>>>>>>> props.auth.user: ',
        JSON.stringify(props.auth.user)
      )

      const userData = {
        user: props.auth.user,
      }

      axios
        .post('/api/payment/confirm-facebook', userData)
        .then((response) => {
          console.log('response: ' + JSON.stringify(response))
        })
        .catch((err) => {
          console.log('Error confirming facebook: ', err)
        })

      axios
        .get('/api/verify-account-status/myfreebirdonboardingdb2')
        .then((response) => {
          const userData = {
            status: response.data.status,
          }
          props.auth.updateUser(userData)
        })
        .catch((err) => {
          console.log('Error getting account status: ', err)
        })
    }

    // Proof of ID step completed. Now post into Circle
    if (onboardingStep === 'db3' && props.auth.user.id !== '') {
      console.log(' >> handlePostIntoCircle...')

      axios
        .get('/api/verify-account-status/myfreebirdonboardingdb3')
        .catch((err) => {
          console.log('Error getting account status: ', err)
        })

      if (!postedIntoCircle) {
        const userData = {
          userId: props.auth.user.id,
          memberIntroduction: props.auth.user.introduction,
        }

        const config = {
          headers: {
            Authorization: `Bearer ${window.sessionStorage.getItem('commAt')}`,
          },
        }

        axios
          .post(`/api/VYGVA82re2f8e2/memberpost`, userData, config)
          .then((response) => {
            if (response.data.success) {
              console.log('success')
              setPostedIntoCircle(true)
            } else {
              console.log('failed to post')
            }
          })
          .catch((err) => {
            console.log('Error adding post into Circle: ', err)
          })
      }
    }
  }, [onboardingStep, props.auth.user])

  const handleCheckEmail = (manualOrAuto) => {
    console.log('handleCheckEmail...')
    axios
      .get('/api/user/email-status')
      .then((response) => {
        console.log('response: ' + JSON.stringify(response))
        if (response.data.emailStatus === 'verified') {
          console.log('email is now verified...')
          const userData = {
            emailStatus: response.data.emailStatus,
          }
          props.auth.updateUser(userData)
          window.open('/onboarding?p=st&emv=y', '_self')
        } else {
          console.log('email is still pending...')
          manualOrAuto === 'manual' && setEmailCheckFail('emf')
        }
      })
      .catch(function (error) {
        console.log('Email status failure: ', error)
        manualOrAuto === 'manual' && setEmailCheckFail('emf')
      })
  }

  const checkEmailManually = () => {
    console.log('checkEmailManually...')
    handleCheckEmail('manual')
  }

  const handleStepUpdated = (step) => {
    setProgressStep(step)
  }

  const setPopupClosed = () => {
    setForbiddenLinkClicked(false, '')
    setEmailCheckFail('')
  }

  const handleProceed = (nextStep) => {
    setLoading(true)
    if (nextStep == 'mfb') {
      window.open('/myfreebird?nf=y', '_self')
    } else if (nextStep == 'mfbu') {
      window.open('/myfreebird?mu=y', '_self')
    } else {
      window.open('/onboarding?p=' + nextStep, '_self')
    }
  }

  const handleGoBack = () => {
    window.history.go(-1)
  }

  const PromoBannerContent = () => {
    //return <img src={`/images/onboarding/price-banner-${onboardingStep}.png`} />
    return null
  }

  const PromoBannerMobContent = () => {
    /*
    return (
      <img src={`/images/onboarding/price-banner-${onboardingStep}-mob.png`} />
    )
    */
    return null
  }

  const ProgressBar = () => {
    return (
      <img
        src={`/images/onboarding/progress-bar-${progressStep.replace('mp3', 'mp')}.svg`}
      />
    )
  }

  const OnboardingBar = () => {
    return (
      <FlexRowOnboarding>
        <FrbLeft>
          {' '}
          <BackButton
            type="submit"
            padding="10px 60px"
            margin="0"
            fontsize="16px"
            onClick={(e) => {
              handleGoBack()
            }}
          >
            {pageText[9]}
          </BackButton>
        </FrbLeft>
        <FrbMiddle>
          <FrbMiddleTop
            style={{
              display:
                onboardingStep === 'pr' ||
                onboardingStep === 'dc' ||
                onboardingStep === 'mp'
                  ? 'block'
                  : 'none',
            }}
          >
            <PromoBanner>
              <PromoBannerContent />
            </PromoBanner>
            <PromoBannerMob>
              <PromoBannerMobContent />
            </PromoBannerMob>
          </FrbMiddleTop>
          <FrbMiddleBottom>
            <ProgressBar />
          </FrbMiddleBottom>
        </FrbMiddle>
        <FrbRight></FrbRight>
      </FlexRowOnboarding>
    )
  }

  const InputPanel = () => {
    switch (onboardingStep) {
      case 'pr':
        // Data colleciton
        return (
          <>
            <OnboardingBar />
            <TopSectionContainer
              padding={'30px 20vw 140px'}
              paddingsm={'0 5vw 140px'}
            >
              <BioOnboarding
                data={props}
                countriesNice={countriesNice}
                onUpdate={handleStepUpdated}
                onComplete={handleProceed}
              />
            </TopSectionContainer>
          </>
        )
      case 'dc':
        // Profile photo
        return (
          <>
            <OnboardingBar />
            <TopSectionContainer
              padding={'30px 20vw 140px'}
              paddingsm={'0 5vw 140px'}
            >
              <PhotoOnboarding
                data={props}
                onUpdate={handleStepUpdated}
                onComplete={handleProceed}
              />
            </TopSectionContainer>
          </>
        )
      case 'mp0':
        // Choose subscription duration
        return (
          <>
            <OnboardingBar />
            <TopSectionContainer
              padding={'30px 0 140px'}
              paddingsm={'0 5vw 140px'}
            >
              <ChooseSubscriptionOnboardingMonthly
                data={props}
                onUpdate={handleStepUpdated}
                onComplete={handleProceed}
                actionRef={actionRef}
              />
            </TopSectionContainer>
          </>
        )
      case 'mp':
        // Membership plan
        return (
          <>
            <OnboardingBar />
            <TopSectionContainer
              padding={'30px 0 140px'}
              paddingsm={'0 5vw 140px'}
            >
              <ChoosePaymentOptionOnboardingMonthly
                data={props}
                onUpdate={handleStepUpdated}
                onComplete={handleProceed}
                actionRef={actionRef}
              />
            </TopSectionContainer>
          </>
        )
      case 'mp3':
        // Membership plan step 3
        return (
          <>
            <OnboardingBar />
            <TopSectionContainer
              padding={'30px 0 140px'}
              paddingsm={'0 5vw 140px'}
            >
              <FeeSubscriptionOnboarding
                data={props}
                setIAminSubscriptionFormPanel={setIAminSubscriptionFormPanel}
                onUpdate={handleStepUpdated}
                onComplete={handleProceed}
              />
            </TopSectionContainer>
          </>
        )
      case 'db2':
        // Payment made, now upload a photo ID
        return (
          <MainSectionContainer>
            <FlexRowOnboarding></FlexRowOnboarding>
            <ProofIdentityOnboarding data={props} onComplete={handleProceed} />
          </MainSectionContainer>
        )
      case 'db3':
        // Onboarding steps complete. Enter your dashboard...
        return (
          <TopSectionContainer>
            <TopSectionAction>
              {' '}
              <Title
                center
                color="#fff"
                size="34px"
                sizemd="34px"
                sizesm="30px"
                lineheight="100%"
                weight="600"
                margin="20px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[10]}`,
                }}
              />
              <SubtitleOnboard
                color="#fff"
                size="20px"
                sizemd="20px"
                sizesm="20px"
                lineheight="100%"
                weight="200"
                margin="26px 10vw"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[11]}`,
                }}
              />
              <img src={'images/onboarding/icon-community.svg'} />
              <ProceedButton
                type="submit"
                padding="10px 60px"
                margin="46px 10vw 26px"
                fontsize="16px"
                onClick={(e) => {
                  handleProceed('mfb')
                }}
              >
                {pageText[12]}
              </ProceedButton>
            </TopSectionAction>
          </TopSectionContainer>
        )
      case 'st':
        // Email address confirmed inform user of the 3 simple steps
        return (
          <TopSectionContainer>
            <TopSectionAction>
              {' '}
              <Title
                center
                color="#fff"
                size="34px"
                sizemd="34px"
                sizesm="30px"
                lineheight="100%"
                weight="600"
                margin="20px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html:
                    queryParams.get('emv') === 'y' ? pageText[4] : pageText[5],
                }}
              />
              <SubtitleOnboard
                color="#fff"
                size="20px"
                sizemd="20px"
                sizesm="20px"
                lineheight="100%"
                weight="200"
                margin="26px 10vw"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[6]}`,
                }}
              />
              <SubtitleOnboard
                color="#fff"
                size="16px"
                sizemd="16px"
                sizesm="16px"
                lineheight="100%"
                weight="200"
                margin="26px 10vw"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[7]}`,
                }}
              />
              <img src={'images/onboarding/icon-community.svg'} />
              <ProceedButton
                type="submit"
                padding="10px 60px"
                margin="46px 10vw 26px"
                fontsize="16px"
                onClick={(e) => {
                  handleProceed('pr')
                }}
              >
                {pageText[8]}
              </ProceedButton>
            </TopSectionAction>
          </TopSectionContainer>
        )
      case 'em':
        // Email address confirmation management
        return (
          <MainSectionContainer>
            <FlexRowOnboarding>
              <BackButton
                type="submit"
                padding="10px 60px"
                margin="0"
                fontsize="16px"
                onClick={(e) => {
                  handleGoBack()
                }}
              >
                {pageText[9]}
              </BackButton>
            </FlexRowOnboarding>
            <EditEmailOnboarding data={props} />
          </MainSectionContainer>
        )
      default:
        // New signup - confirm email address
        return (
          <TopSectionContainer>
            <TopSectionAction>
              {' '}
              <Title
                center
                color="#fff"
                size="34px"
                sizemd="34px"
                sizesm="26px"
                lineheight="100%"
                weight="600"
                margin="20px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[0]}`,
                }}
              />
              <SubtitleOnboard
                color="#fff"
                size="20px"
                sizemd="18px"
                sizesm="16px"
                lineheight="100%"
                weight="200"
                margin="26px 4vw"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[1].replace('{*}', props.auth.user.email)}`,
                }}
              />
              <img src={'images/onboarding/icon-email.svg'} />
              <ProceedButton
                type="submit"
                padding="10px 60px"
                margin="46px 10vw 26px"
                fontsize="16px"
                onClick={(e) => {
                  handleProceed('em')
                }}
              >
                {pageText[2]}
              </ProceedButton>
              <ActionButton
                type="submit"
                padding="10px 60px"
                margin="26px 10vw 26px"
                fontsize="16px"
                onClick={() => {
                  checkEmailManually()
                }}
              >
                {pageText[3]}
              </ActionButton>
            </TopSectionAction>
          </TopSectionContainer>
        )
    }
  }

  if (pageText.length === 0 || onboardingStep === '' || !props.auth.user) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border onboarding-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[22]}</span>
        </div>
      </div>
    )
  }
  return (
    <MyFreebirdSection className={'my-freebird-section'}>
      <NewHeaderOnboarding />
      <InputPanel />
      <MyFreebirdPopup
        pageText={pageText}
        user={props.auth.user}
        forbiddenLinkClicked={forbiddenLinkClicked}
        newMemberMessage={emailCheckFail}
        onUpdate={setPopupClosed}
      />
      <MyFreebirdOpacityScreen
        user={props.auth.user}
        forbiddenLinkClicked={forbiddenLinkClicked}
        newMemberMessage={emailCheckFail}
      />
    </MyFreebirdSection>
  )
}

export default withRouter(withAuth(MyFreebirdOnboardingSteps))
